export default "__VITE_ASSET__Dlw$vf0S__"